import { render, staticRenderFns } from "./PanelUR.vue?vue&type=template&id=46e8f831&scoped=true&"
import script from "./PanelUR.vue?vue&type=script&lang=js&"
export * from "./PanelUR.vue?vue&type=script&lang=js&"
import style0 from "./PanelUR.vue?vue&type=style&index=0&id=46e8f831&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8f831",
  null
  
)

export default component.exports